import { defineMessages } from 'react-intl';

export default defineMessages({
    Actions: {
        id: 'quoteandbind.pa.views.pa-household-member.Actions',
        defaultMessage: 'Actions'
    },
    ActionsMobile: {
        id: 'quoteandbind.pa.views.pa-household-member.Actions Mobile',
        defaultMessage: 'Actions'
    },
    AddDriver: {
        id: 'quoteandbquoteandbind.pa.directives.templates.pa-household-members.Add Household Member',
        defaultMessage: 'Add Household Member'
    },
    ModernProductAddDriver: {
        id: 'quoteandbquoteandbind.pa.directives.templates.pa-household-members.Add Non Driver',
        defaultMessage: 'Add Non Driver'
    },
    DriverPopupTitle: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Add a household member',
        defaultMessage: 'Add a household member'
    },
    ModernProductDriverPopupTitle: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Add a non driver',
        defaultMessage: 'Add a non driver'
    },
    DateOfBirth: {
        id: 'quoteandbind.pa.views.pa-household-member.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    DateOfBirthMobile: {
        id: 'quoteandbind.pa.views.pa-household-member.Date of Birth Mobile',
        defaultMessage: 'Date of Birth'
    },
    EditDriverPopupTitle: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Edit an excluded drivequoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Edit a household member',
        defaultMessage: 'Edit a household member'
    },
    ModernProductEditDriverPopupTitle: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Edit an excluded drivequoteandbind.pa.directives.templates.pa-add-exdriver-or-household.Edit a non driver',
        defaultMessage: 'Edit a non driver'
    },
    DriverAddedAlert: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.x has been added',
        defaultMessage: '{person} has been added.'
    },
    DriverAddedAlertNewProduct: {
        id: 'quoteandbind.pa.directives.templates.pa-add-exdriver-or-household.x has been added as a non driver.',
        defaultMessage: '{person} has been added as a non driver.'
    },
    DriverRemoved: {
        id: 'quoteandbind.pa.directives.templates.pa-add-household.x has been removed',
        defaultMessage: '{person} has been removed. <a>Undo</a>'
    },
    DriverHeader: {
        id: 'quoteandbind.pa.directives.templates.pa-household-members.Household Members',
        defaultMessage: 'Household Members'
    },
    ModernProductDriverHeader: {
        id: 'quoteandbind.pa.directives.templates.pa-household-members.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    Gender: {
        id: 'quoteandbind.pa.views.pa-household-member.Gender',
        defaultMessage: 'Gender'
    },
    GenderMobile: {
        id: 'quoteandbind.pa.views.pa-household-member.Gender Mobile',
        defaultMessage: 'Gender'
    },
    Name: {
        id: 'quoteandbind.pa.views.pa-household-member.Name',
        defaultMessage: 'Name'
    },
    NameMobile: {
        id: 'quoteandbind.pa.views.pa-household-member.Name Mobile',
        defaultMessage: 'Name'
    },
    ReasonNotListed: {
        id: 'quoteandbind.pa.views.pa-household-member.Reason not Listed',
        defaultMessage: 'Reason not Listed'
    },
    ReasonNotListedMobile: {
        id: 'quoteandbind.pa.views.pa-household-member.Reason not Listed Mobile',
        defaultMessage: 'Reason not Listed'
    },
    RelationshipToInsured: {
        id: 'quoteandbind.pa.views.pa-household-member.Relationship to Insured',
        defaultMessage: 'Relationship to Insured'
    },
    RelationshipToInsuredMobile: {
        id: 'quoteandbind.pa.views.pa-household-member.Relationship to Insured Mobile',
        defaultMessage: 'Relationship to Insured'
    },
    DriverParagraph: {
        id: 'quoteandbind.pa.directives.templates.pa-household-members.Tell us about any additional household members who are not listed above',
        defaultMessage: 'Tell us about any additional household members who are not listed above'
    },
    ModernProductDriverParagraph: {
        id: 'quoteandbind.pa.directives.templates.pa-household-members.Tell us about any additional non drivers who are not listed above',
        defaultMessage: 'Tell us about any additional non drivers who are not listed above'
    },
    SelectDriver: {
        id: 'quoteandbind.pa.views.pa-household-driver.SelectDriver',
        defaultMessage: 'Please enter the missing information. This is a required field.'
    }
});
